<template>
  <div id="cidadaos-acompanhados-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    equipe: {
      type: [Object, Boolean],
      default: false,
    },
    nivel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartOptions: {},
    }
  },
  created() {
    let categories = []

    if (this.nivel == '2') {
      categories = [
        ['Não', 'Acompanhados'],
        ['Acompanhados', 'Sem critério'],
        ['Acompanhados', 'Idosos/Crianças'],
        ['Acompanhados', 'BPC/PBF'],
        ['Acompanhados', 'Idosos/Crianças', '+ BPC/PBF'],
      ]
    }

    if (this.nivel == '3') {
      categories = [
        ['Não', 'Acompanhados'],
        ['Acompanhados', 'Sem critério'],
        ['Acompanhados', 'Idosos/Crianças'],
        ['Acompanhados', 'BPC/PBF'],
        ['Acompanhados', 'Idosos/Crianças', '+ BPC/PBF'],
      ]
    }

    this.chartOptions = {
      title: {
        text: 'Cidadãos Acompanhados',
        align: 'center',
        style: {
          fontSize: '15px',
          fontWeight: 'bold',
          fontFamily: undefined,
          color: '#000',
        },
      },
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function (chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },
      colors: ['#156082', '#E97132', '#196B24', '#0F9ED5', '#e6e600'],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const label = categories[dataPointIndex].join(' ')
          const value = series[seriesIndex][dataPointIndex]
          return `<div class="apex-tooltip">
                <strong>${label}</strong>
                <hr>
                 <strong>${value}</strong>
              </div>`
        },
      },
      xaxis: {
        categories: [...categories],
        labels: {
          style: {
            colors: ['#156082', '#E97132', '#196B24', '#0F9ED5'],
            fontSize: '12px',
          },
        },
      },
    }
  },
}
</script>

<style lang="scss">
#cidadaos-acompanhados-chart {
  margin: 30px 0;
  .apex-tooltip {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    font-size: 13px;
    color: #333;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    max-width: 200px;
    white-space: normal;
    hr {
      margin: 5px 0;
    }
  }
}
</style>
